import DashboardIcon from "@mui/icons-material/Dashboard";
export const LayoutToolConfig = {
  name: "LAYOUT",
  tool: "LayoutTool",
  icon: <DashboardIcon />,
  isLayoutPicker: true,
};